import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { NgxCaptchaModule } from 'ngx-captcha';
import { FilterPipe } from '../modules/map/components/item/filter.pipe';
import { SystemEffects } from '../shared/system/system.effects';
import * as fromSystem from '../shared/system/system.reducer';
import { DisableControlDirective } from './directives/disable-control.directive';
import { ShowSpinnerDirective } from './directives/show-spinner.directive';
import { SafePipe } from './pipes/safe.pipe';

@NgModule({
  imports: [
    EffectsModule.forFeature([SystemEffects]),
    StoreModule.forFeature('system', fromSystem.reducer),
  ],
  exports: [
    DisableControlDirective,
    SafePipe,
    ShowSpinnerDirective,
    NgxCaptchaModule,
    FilterPipe,
    MatProgressSpinnerModule,
    MatIconModule,
  ],
  declarations: [
    DisableControlDirective,
    SafePipe,
    ShowSpinnerDirective,
    FilterPipe,
  ],
  providers: [],
})
export class SharedModule {}
